export const federalLotteriesColumns = [
  { label: 'Ações', value: 'actions', className: 'w-10' },
  { label: 'Número do concurso', value: 'number' },
  { label: 'Data do sorteio', value: 'date' },
]
